import React, { useState } from 'react';
import VoirPlusButton from './VoirPlusButton';

const MAX_CHARACTERS = 300;

interface TruncatedListProps {
  items: string[];
}

const TruncatedList: React.FC<TruncatedListProps> = ({ items }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const totalCharacters = items.join('').length;
  const shouldTruncate = totalCharacters > MAX_CHARACTERS;

  if (!shouldTruncate) {
    return (
      <ul>
        {items.map((item, index) => (
          <li key={index} className="break-words">
            {item}
          </li>
        ))}
      </ul>
    );
  }

  const renderTruncatedContent = () => {
    let currentLength = 0;
    const truncatedItems: string[] = [];

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (currentLength + item.length <= MAX_CHARACTERS) {
        truncatedItems.push(item);
        currentLength += item.length;
      } else {
        const remainingCharacters = MAX_CHARACTERS - currentLength;
        if (remainingCharacters > 0) {
          truncatedItems.push(
            item.substring(0, remainingCharacters) + '\u2026',
          );
        }
        break;
      }
    }

    return (
      <div>
        <ul>
          {truncatedItems.map((item, index) => (
            <li key={index} className="break-words">
              {item}
            </li>
          ))}
        </ul>
        <VoirPlusButton isExpanded={false} setIsExpanded={setIsExpanded} />
      </div>
    );
  };

  return (
    <div>
      {!isExpanded ? (
        renderTruncatedContent()
      ) : (
        <div>
          <ul>
            {items.map((item, index) => (
              <li key={index} className="break-words">
                {item}
              </li>
            ))}
          </ul>
          <div className="mt-2">
            <VoirPlusButton isExpanded setIsExpanded={setIsExpanded} />
          </div>
        </div>
      )}
    </div>
  );
};

export default TruncatedList;
